import React, { useState } from 'react';
import { X, Smartphone } from 'lucide-react';
import appQr from '../assets/images/Kopartner.png';
import { PLAY_STORE_URL } from './AppDownloadPopup';

const STORAGE_KEY = 'kopartner_fixed_qr_dismissed';

const FixedAppQr = () => {
  const [hidden, setHidden] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });

  const dismiss = () => {
    setHidden(true);
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch (_) {}
  };

  if (hidden) return null;

  return (
    <div
      className="fixed right-2 sm:right-3 top-1/2 -translate-y-1/2 z-40 flex flex-col items-center pointer-events-none"
      data-testid="fixed-app-qr"
    >
      <div className="relative bg-white rounded-xl sm:rounded-2xl shadow-2xl border border-purple-100 p-2 sm:p-2.5 w-[84px] sm:w-[108px] pointer-events-auto">
        <button
          type="button"
          onClick={dismiss}
          className="absolute -top-2 -left-2 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gray-800 text-white flex items-center justify-center hover:bg-gray-700 shadow-md"
          aria-label="Hide app QR"
        >
          <X size={11} className="sm:w-3 sm:h-3" />
        </button>

        <a
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="block group"
          title="Download KoPartner app"
        >
          <div className="flex items-center justify-center gap-1 mb-1 text-purple-700">
            <Smartphone size={11} className="shrink-0 sm:w-3 sm:h-3" />
            <span className="text-[9px] sm:text-[10px] font-bold uppercase tracking-wide">Install App</span>
          </div>
          <div className="rounded-lg sm:rounded-xl border-2 border-purple-200 bg-white p-1 sm:p-1.5 group-hover:border-purple-400 transition-colors">
            <img
              src={appQr}
              alt="KoPartner app install QR"
              className="w-[60px] h-[60px] sm:w-[76px] sm:h-[76px] object-contain mx-auto"
            />
          </div>
          <p className="text-[8px] sm:text-[9px] text-center text-gray-500 mt-1 leading-tight font-medium">
            Scan &amp; Download
          </p>
        </a>
      </div>
    </div>
  );
};

export default FixedAppQr;
